import { TOOL_TYPES } from 'constants/constants';
import { VerificationType } from 'services/EpdClient';
import { ToolStandardEpdOptionModel } from 'types/tools/ToolStandardEpdOptionModel';
import { ToolVersionStandardEpdOptionModel } from 'types/tools/ToolVersionStandardEpdOptionModel';
import { Option } from 'types/types';

export default function filterToolsForEpdVerificationIntoOptions(
  tools: ToolStandardEpdOptionModel[],
  versions: ToolVersionStandardEpdOptionModel[],
  verificationType: VerificationType,
  companyName: string
): (Option & { versions: Option[] })[] {
  // Ed: this is disgusting, even in the updated tools flow (Sep 2025) pre-verified EPD/LCA tools can't be limited to a company. What a misery
  const removedExclusiveTools = tools.filter(
    (t) =>
      !(t.name === 'EPD generator for Gunnar Prefab AB' && companyName !== 'Gunnar Prefab AB') &&
      !(t.id === 'ee378866-dc59-4c62-5008-08dac88134de' && companyName !== 'DOVISTA A/S') &&
      !(t.name === 'Tyréns EPD-generator 3.0.0 - Gefle wood' && companyName !== 'Gefle Wood AB')
  );

  let removedInappropriateType: ToolStandardEpdOptionModel[];
  if (verificationType === VerificationType.EPDPreverifiedTool) {
    removedInappropriateType = removedExclusiveTools.filter((t) => t.toolType === TOOL_TYPES.INTEGRATED);
  } else {
    removedInappropriateType = removedExclusiveTools.filter((t) => t.toolType !== TOOL_TYPES.INTEGRATED);
  }

  const utcNowYyyyMmDd = utcDateToYyyyMmDd(new Date());
  return removedInappropriateType.map((t) => {
    const thisToolVersions: Option[] = versions
      .filter((v) => v.toolId === t.id)
      .map((v) => ({
        value: v.id,
        label: v.name,
        isDisabled: v.validityDate !== null && v.validityDate < utcNowYyyyMmDd,
      }));
    return {
      value: t.id,
      label: t.name,
      isDisabled: thisToolVersions.length === 0 || thisToolVersions.every((v) => v.isDisabled),
      versions: thisToolVersions,
    };
  });
}

function utcDateToYyyyMmDd(date: Date): string {
  const yyyy = date.getUTCFullYear();
  const mm = (date.getUTCMonth() + 1).toString().padStart(2, '0');
  const dd = date.getUTCDate().toString().padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}
